import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/icon-map-pin.svg")